module.exports = __webpack_public_path__ + "img/entrance_story_card3.c76b266f.svg";